import { render, staticRenderFns } from "./order_schedule.vue?vue&type=template&id=19dc4f56&scoped=true&"
import script from "./order_schedule.vue?vue&type=script&lang=js&"
export * from "./order_schedule.vue?vue&type=script&lang=js&"
import style0 from "./order_schedule.vue?vue&type=style&index=0&id=19dc4f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc4f56",
  null
  
)

export default component.exports